module.exports = __webpack_public_path__ + "static/media/gesso.55cb86da.svg";